/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1SsoimageIdVideo201,
  PostApiV1SsoimageIdVideo400,
  PostApiV1SsoimageIdVideo401,
  PostApiV1SsoimageIdVideo404,
  PostApiV1SsoimageIdVideo500,
  PostApiV1SsoimageIdVideoMutationRequest,
  PostApiV1SsoimageIdVideoMutationResponse,
  PostApiV1SsoimageIdVideoPathParams,
} from "../../types/SSOImageController/PostApiV1SsoimageIdVideo.ts";
import { eViewPortSchema } from "../eViewPortSchema.ts";
import { uploadSSOVideoResponseSchema } from "../uploadSSOVideoResponseSchema.ts";

export const postApiV1SsoimageIdVideoPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1SsoimageIdVideoPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1SsoimageIdVideo201Schema = z.lazy(
  () => uploadSSOVideoResponseSchema,
) as unknown as ToZod<PostApiV1SsoimageIdVideo201>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1SsoimageIdVideo400Schema =
  z.any() as unknown as ToZod<PostApiV1SsoimageIdVideo400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1SsoimageIdVideo401Schema =
  z.any() as unknown as ToZod<PostApiV1SsoimageIdVideo401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1SsoimageIdVideo404Schema =
  z.any() as unknown as ToZod<PostApiV1SsoimageIdVideo404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1SsoimageIdVideo500Schema =
  z.any() as unknown as ToZod<PostApiV1SsoimageIdVideo500>;

export const postApiV1SsoimageIdVideoMutationRequestSchema = z.object({
  File: z.instanceof(File),
  CultureInfo: z.string(),
  ViewPort: z
    .lazy(() => eViewPortSchema)
    .describe("1 = Desktop | 2 = Mobile | "),
}) as unknown as ToZod<PostApiV1SsoimageIdVideoMutationRequest>;

export const postApiV1SsoimageIdVideoMutationResponseSchema = z.lazy(
  () => postApiV1SsoimageIdVideo201Schema,
) as unknown as ToZod<PostApiV1SsoimageIdVideoMutationResponse>;
